import React, { useContext, useEffect, useState } from "react";
import { Link, useParams, withRouter } from "react-router-dom";
import StatusFooter from "./StatusFooter";
import NoEvent from "./NoEvent";
import { EventModel, EventParams, State } from "./EventModel";
import StartEvent from "./StartEvent";
import EventPlaylists from "./EventPlaylists";
import { Button } from "reactstrap";
import NarrowContent from "./NarrowContent";
import ActionsWrapper from "./ActionsWrapper";
import { isStarted } from "../utils/apiUtils";
import { EventHubContext } from "./EventHubContext";
import useAPI from "./useAPI";

const RunEvent = (): JSX.Element => {
  const { eventId } = useParams<EventParams>();
  const { subscribe } = useContext(EventHubContext);
  const [event, setEvent] = useState<EventModel | null>(null);
  const [error, setError] = useState<Error>();

  useAPI<EventModel>(`api/events/${eventId}`, {}, setEvent, setError);

  useEffect(() => {
    if (event && subscribe) {
      subscribe(event, setEvent);
    }
  }, [event, subscribe]);

  return (
    <NarrowContent className="app-page app-page-run-event">
      {event ? (
        <>
          {event.state < State.Started && <StartEvent event={event} />}
          {isStarted(event) && (
            <EventPlaylists event={event} onError={setError} onEventUpdated={setEvent}>
              <ActionsWrapper>
                <Button color="secondary" tag={Link} to={"/finish/" + event.id}>
                  Finish Event
                </Button>
                <Button
                  className="btn-variant btn-tertiary"
                  tag={Link}
                  to="/events"
                >
                  Return to Events Dashboard
                </Button>
              </ActionsWrapper>
            </EventPlaylists>
          )}
        </>
      ) : (
        <NoEvent />
      )}
      <StatusFooter error={error} />
    </NarrowContent>
  );
};

export default withRouter(RunEvent);
